import AuthorizationCard from './AuthorizationCard';

export default AuthorizationCard;
